// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { TerceraMessageBox } from '@front/controls/screen/TerceraMessageBox';
import { ScreensNames } from '@front/controls/UtilsClasses/FactoryConstants';
export class InvestingMessageBox extends TerceraMessageBox {
    constructor() {
        super();
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
    }
    oncomplete() {
        super.oncomplete();
        document.addEventListener('click', this.handleOutsideClick, true);
    }
    onteardown() {
        document.removeEventListener('click', this.handleOutsideClick, true);
        super.onteardown();
    }
    getType() {
        return ScreensNames.InvestingMessageBox;
    }
    handleOutsideClick(event) {
        const rootElement = this.find('*');
        if (!isNullOrUndefined(rootElement) && !rootElement.contains(event.target)) {
            this.cancelClick();
        }
    }
    static Show(headerText, bodyText, type, okCallBack, cancelCallBack, showNextTimeChB, hideCancel, errorText, addData, skipOnTeardown = false) {
        return TerceraMessageBox.Show(headerText, bodyText, type, okCallBack, cancelCallBack, showNextTimeChB, hideCancel, errorText, addData, skipOnTeardown, new InvestingMessageBox());
    }
}
TerceraMessageBox.extendWith(InvestingMessageBox, {
    data: function () {
        return {
            showHeader: false
        };
    }
});
